import { MeasureDataSplitDetails } from "store/types";

export interface WideCell {
  displayValue: string;
  dataId: number;
}

export interface WideRow {
  key: string;
  batchIds: number[]; // all batch IDs contributing to this row
  date: string;       // raw ISO for filtering/sorting
  round: string;
  investor: string | null; // null = aggregated parent
  bankAccount: string | null;
  cells: Record<string, WideCell | null>;
  children: WideRow[];
  allDataIds: number[];
  isAggregated: boolean;
}

export interface WideFilters {
  dateFrom: string | null; // ISO midday string (toIsoMidday), avoids timezone issues
  dateTo: string | null;
  investors: { id: string; name: string }[];
  rounds: { id: string; name: string }[];
  visibleMeasures: string[]; // empty = all visible
}

export interface WideEditState {
  splitDetails: MeasureDataSplitDetails;
  batchId: number;
  investorName: string | null; // null = all investors
}

export const defaultWideFilters: WideFilters = {
  dateFrom: null,
  dateTo: null,
  investors: [],
  rounds: [],
  visibleMeasures: []
};
